// LOADER CONSTANTS
export const SET_LOADING_TRUE = "SET_LOADING_TRUE";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";

// PERSONAL INFO REDUCER CONSTANTS
export const VERIFY_EMAIL_IN_PROGRESS = "VERIFY_EMAIL_IN_PROGRESS";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILED = "VERIFY_EMAIL_FAILED";
export const REFRESH_EXISTING_USER = "REFRESH_EXISTING_USER";
export const LOG_USER_OUT = "LOG_USER_OUT";

// OTP REDUCER CONSTANTS
export const VERIFY_OTP_IN_PROGRESS = "VERIFY_OTP_IN_PROGRESS";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILED = "VERIFY_OTP_FAILED";

// GOAL REDUCER CONSTANTS
export const GET_GOALS_IN_PROGRESS = "GET_GOALS_IN_PROGRESS";
export const GET_GOALS_SUCCESS = "GET_GOALS_SUCCESS";
export const GET_GOALS_FAILED = "GET_GOALS_FAILED";
export const REFRESH_GOALS = "REFRESH_GOALS";

// UPDATE GOAL REDUCER CONSTANTS
export const UPDATE_GOALS_IN_PROGRESS = "UPDATE_GOALS_IN_PROGRESS";
export const UPDATE_GOALS_SUCCESS = "UPDATE_GOALS_SUCCESS";
export const UPDATE_GOALS_FAILED = "UPDATE_GOALS_FAILED";

// ARCHIVE GOAL REDUCER CONSTANTS
export const ARCHIVE_GOALS_IN_PROGRESS = "ARCHIVE_GOALS_IN_PROGRESS";
export const ARCHIVE_GOALS_SUCCESS = "ARCHIVE_GOALS_SUCCESS";
export const ARCHIVE_GOALS_FAILED = "ARCHIVE_GOALS_FAILED";

// NEW GOAL REDUCER CONSTANTS
export const NEW_GOALS_IN_PROGRESS = "NEW_GOALS_IN_PROGRESS";
export const NEW_GOALS_SUCCESS = "NEW_GOALS_SUCCESS";
export const NEW_GOALS_FAILED = "NEW_GOALS_FAILED";
